export const EXPORT_REPORT = 'SEARCH/EXPORT_REPORT';
export const EXPORT_REPORT_SUCCESS = 'SEARCH/EXPORT_REPORT_SUCCESS';
export const EXPORT_REPORT_ERROR = 'SEARCH/EXPORT_REPORT_ERROR';
export const SET_REPORT_TYPE = 'REPORTS/SET_REPORT_TYPE';
export const SET_PLATFORM = 'REPORTS/SET_PLATFORM';
export const SET_ORDER_TYPE = 'REPORTS/SET_ORDER_TYPE';
export const SET_START_DATE = 'REPORTS/SET_START_DATE';
export const SET_END_DATE = 'REPORTS/SET_END_DATE';